export default __webpack_public_path__ + "static/media/tips.07e91057.svg";